import { DEFAULT_CUSTOMER_ID, DEFAULT_DRIVER_ID, FIELDS } from './constants';
import { genderMap } from './genderHelper';

const BASE_INSURER = {
  [FIELDS.BIRTHDATE]: '',

  [FIELDS.DRIVING_LICENSE_IS_FIRST]: true,
  [FIELDS.DRIVING_LICENSE_ISSUE_DATE]: '',
  [FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER]: '',

  [FIELDS.FULL_NAME]: '',
  [FIELDS.GENDER]: genderMap.MALE,

  [FIELDS.PREVIOUS_DRIVING_LICENSE_ISSUE_DATE]: '',
  [FIELDS.PREVIOUS_DRIVING_LICENSE_SERIES_AND_NUMBER]: '',
};

export const defaultDriver = { ...BASE_INSURER, [FIELDS.ID]: DEFAULT_DRIVER_ID };

export const defaultInsurer = {
  ...BASE_INSURER,

  [FIELDS.ID]: DEFAULT_CUSTOMER_ID,
  [FIELDS.MOBILE_PHONE]: '',
  [FIELDS.EMAIL]: '',
  [FIELDS.PASSPORT_SERIES_AND_NUMBER]: '',
  [FIELDS.PASSPORT_ISSUE_DATE]: '',
  [FIELDS.PASSPORT_ISSUER_CODE]: '',
  [FIELDS.PASSPORT_ISSUER]: '',
  [FIELDS.BIRTH_PLACE]: '',
  [FIELDS.REGISTRATION_INDEX]: '',
  [FIELDS.REGISTRATION_ADDRESS]: '',
  [FIELDS.IS_DRIVER]: true,
  [FIELDS.OWNER_IS_DRIVER]: true,
  [FIELDS.IS_INSURER]: true,
  [FIELDS.OWNER_IS_INSURER]: true,
};

export const anketaInsurance = {
  ...defaultInsurer,
  [FIELDS.DRIVERS]: [],
  [FIELDS.FILLED_CUSTOMERS]: [],
  [FIELDS.CUSTOMER_ROLES]: null,
  currentSavedData: null,
  [FIELDS.REGISTRATION_ADDRESS_DA_DATA_INFO]: {},
  [FIELDS.KASKO_INSURER]: {
    ...defaultInsurer,
    [FIELDS.REGISTRATION_ADDRESS_DA_DATA_INFO]: {},
    [FIELDS.ERRORS]: {},
  },
  [FIELDS.KASKO_INSURER_IS_DRIVER]: false,
  savedInsurer: null,
};

export const SAVING_EXCEPTIONS = [
  FIELDS.FILLED_CUSTOMERS,
  FIELDS.CUSTOMER_ROLES,
  'currentSavedData',
  FIELDS.ERRORS,
  'networkError',
  'saveFetch',
];
